import { h, JSX } from 'preact';
import ObservingComponent from '../componentBases/observingComponent';
import CustomerDetailPageProps from './customerDetailPageProps';
import Button from '../buttons/button';
import ConfirmationPrompt from '../containers/confirmationPrompt';
import Alert from '../alerts/alert';
import ButtonColors from '../buttons/buttonColors';
import AllMeetingsTable from '../meetings/allMeetingsTable';

class CustomerDetailPage extends ObservingComponent<CustomerDetailPageProps> {

    public componentWillMount(): void {
        this.registerUpdateObserver(this.props.page.observationProvider);
    }

    public render({ page }: CustomerDetailPageProps): JSX.Element {
        const customer = page.form?.model;
        const customerName = customer ? `${customer.firstName || ''} ${customer.lastName || ''}`.trim() : '';

        return (
            <div>
                <ConfirmationPrompt confirmationPrompt={page.confirmationPrompt} />
                <Alert alert={page.alert} />

                <div>
                    <div class="page-title">Customer Detail</div>
                    <div class="customer-detail-page">
                        <div class="page-heading">
                            <h3>{customerName || page.title}</h3>
                            <div class="btn-container flex">
                                {/* <Button
                                    color={ButtonColors.Secondary}
                                    className="btn-icon btn-lg"
                                    button={page.helpButton} /> */}

                                <Button
                                    color={ButtonColors.Secondary}
                                    className="btn-icon"
                                    button={page.quizButton} />

                                {(1) && (
                                    <Button
                                        color={ButtonColors.Secondary}
                                        className="btn-icon"
                                        button={page.editButton} />
                                )}

                                <Button
                                    color={ButtonColors.Secondary}
                                    className="btn-icon"
                                    button={page.eventHistoryButton} />

                                <Button
                                    className="btn-icon"
                                    color={ButtonColors.Secondary}
                                    button={page.deactivateButton} />
                            </div>
                        </div>

                        <div class="customer-detail-container">
                            <div class={`customer-info-panel`}>
                                <div class="customer-company">
                                    {customer?.customerCompanyName || ''}
                                </div>

                                <div class="customer-info-section">
                                    <div class="info-label">Rank/Position</div>
                                    <div class="info-value">{customer?.rank || ''}</div>
                                </div>

                                <div class="customer-info-section">
                                    <div class="info-label">Title</div>
                                    <div class="info-value">{customer?.title || ''}</div>
                                </div>

                                <div class="customer-info-section">
                                    <div class="info-label">Email</div>
                                    <div class="info-value">{customer?.email || ''}</div>
                                </div>

                                <div class="customer-info-section">
                                    <div class="info-label">Phone</div>
                                    <div class="info-value">{customer?.phone || ''}</div>
                                </div>

                                <div class="customer-info-section">
                                    <div class="info-label">ID | Date Added</div>
                                    <div class="info-value">{customer?.id || ''} | {new Date(customer?.createdDateTime).toLocaleDateString() || ''}</div>
                                </div>

                                <div class="customer-info-section">
                                    <div class="info-label">Comments</div>
                                    <div class="info-value">
                                        {customer?.comments || ''}
                                    </div>
                                </div>

                                <div class="customer-info-section">
                                    <div class="info-label">Annual Engagements</div>
                                    <div class="info-value">
                                        {customer?.comments || ''}
                                    </div>
                                </div>
                            </div>

                            <div class="customer-content-area">
                                <AllMeetingsTable table={page.meetingsTable} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CustomerDetailPage;
